const authorizationStatus = {
    INACTIVE : 0,

    ACTIVE : 1

};

angular.module('gw-um-j2js')
    .constant('authorizationStatus', authorizationStatus);